export default __webpack_public_path__ + "static/media/x33-logo-cny-dragon.d80a74df.png";